// extracted by mini-css-extract-plugin
export default {"dialogContent":"DeleteReportDialog_dialogContent__n1Ubh"};